import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const BusinessPlanModal = (props) => <RequestDetailModal {...props} />;

export default BusinessPlanModal;
